<template>
  <v-card width="428">
    <v-card-title>
      <p class="subtitle-1 font-weight-bold">
        {{ textDelete }}
      </p>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn data-test-type="cancel" text @click="$emit('close')"
        >Cancel</v-btn
      >
      <v-btn
        :data-test-type="actionName"
        color="primary"
        text
        @click="$emit('delete')"
        :loading="loading"
      >
        {{ actionName }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// TODO: need refactor everywhere
export default {
  name: 'DefaultConfirmation',
  props: {
    typeEntity: {
      type: String,
      default: 'object'
    },
    actionName: {
      type: String,
      default: 'delete'
    },
    textDelete: {
      type: String,
      default: 'Delete this object completely?'
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
